import BaseFilter from "./BaseFilter";
export default class CheckBoxFilter extends BaseFilter {
    constructor($node) {
        super();
        this.$node = $node;
        this.filterProperty = $node.data('filterproperty');
        this.option = $node.data('filteroption');
    }
    getData() {
        var _a;
        return {
            key: (_a = this.$node.attr("name")) !== null && _a !== void 0 ? _a : "unkown",
            value: this.$node.is(":checked")
        };
    }
    setValue(value) {
        if (value) {
            this.$node.attr('checked', 'checked');
        }
        else {
            this.$node.removeAttr('checked');
        }
    }
    match($item) {
        var _a, _b;
        const nodeValue = this.$node.val();
        const valueStr = nodeValue === null || nodeValue === void 0 ? void 0 : nodeValue.toString();
        const checked = this.$node.is(":checked");
        const checkBoxValues = nodeValue === null || nodeValue === void 0 ? void 0 : nodeValue.toString().split(',').map(function (item) {
            return item.trim();
        });
        if (checkBoxValues === undefined || checkBoxValues.length == 0)
            return true;
        const data = String($item.data(this.filterProperty));
        if (!checked) {
            if ((_a = this.option) === null || _a === void 0 ? void 0 : _a.reverse) {
                return !checkBoxValues.includes(data);
            }
            return true;
        }
        if (!valueStr)
            return true;
        if ((_b = this.option) === null || _b === void 0 ? void 0 : _b.reverse) {
            return true;
        }
        else {
            return checkBoxValues.includes(data);
        }
    }
}
